import moment from "moment";

export const convertToLocaleDateTime = (input = new Date()) => {
  try {
    if (!input) throw new Error("Invalid date input");

    // Get the system's current timezone dynamically (respects timezone changes)
    const userTimeZone = moment.tz.guess();
    const userLocale = navigator?.language || "en-US";

    // Ensure input is properly parsed (handles both strings & Date objects)
    if (input instanceof Date) {
      input = input.toISOString(); // Convert Date object to string
    }

    // Define possible input formats
    const formats = [
      "DD-MMM-YYYY HH:mm:ss", // "01-Mar-2025 07:24:22"
      "DD-MM-YYYY HH:mm:ss", // "03-01-2025 17:25:51" (European)
      "MM-DD-YYYY HH:mm:ss", // "03-01-2025 17:25:51" (US)
      "YYYY-MM-DDTHH:mm:ss.SSS", // "2025-03-01T07:24:22.229"
      moment.ISO_8601, // Fully supports all ISO formats
    ];

    // Parse the input & convert to system's latest timezone
    let date = moment.tz(input, formats, true, "UTC").tz(userTimeZone);

    if (!date.isValid()) throw new Error("Invalid date format");

    // Format in "DD-MMM-YYYY HH:mm:ss" (24-hour format)
    return date.locale(userLocale).format("DD-MMM-YYYY HH:mm:ss");
  } catch {
    return "Invalid date input";
  }
};
